<template>
    <v-container fluid>
        <!-- <v-dialog v-model="show" > -->
            <v-card elevation="0" class="mb-16">
                <v-toolbar>
                    <v-icon>library_books</v-icon>
                    <v-toolbar-title class="font-weight-light"> 
                        <v-row>
                            <v-col >
                                <div>&nbsp;Resúmen Ejecutivo - Legajo Nº {{listData.cuenta}}</div>
                                <span v-if="showId" class="caption">ID Persona: {{infoPersona.id}}</span>
                            </v-col>
                            
                        </v-row>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.stop="hideActiveTask"><v-icon>close</v-icon></v-btn>                    
                </v-toolbar>

                <v-progress-linear v-if="loadingData" indeterminate size="16"> </v-progress-linear>

                <v-card-title >
                    <v-row no-gutters> 
                        <v-col>
                            <v-banner color="secondary" dark sticky icon="person_search" small single-line>
                                <div>Información de la persona : {{listData.nombre}} - <span @click="showId = true"> D.N.I {{listData.documento}}</span></div>
                            </v-banner>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text >
                    <v-container >
                        <v-card color="blue lighten-4" >
                        <v-list>
                            <v-list-item  >
                                <v-list-item-title><strong> Situación Laboral: </strong>{{this.listData.situacionLaboral}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title><strong> Actividad Laboral: </strong> {{this.listData.actividadLaboral}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title><strong> Empleador: </strong> {{this.listData.empleador}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title><strong>Ingresos: </strong> ${{this.listData.ingreso}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title><strong> Score Siisa: </strong> {{this.listData.score}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                        </v-card>
                    </v-container>
                </v-card-text>  


                <v-card-title>
                    <v-row no-gutters> 
                        <v-col>
                            <v-banner color="secondary" dark sticky icon="payment" small single-line>
                                <span>Último Crédito : {{ listData.credito? 'Nº '+ listData.credito : 'No poseé crédito activo' }}</span>
                                <template v-slot:actions>
                                    <app-acciones-comunes :personaId="listData.id" :solicitudId="listData.creditoId" :ocultarAnalisisConsulta="true"> </app-acciones-comunes>                                    
                                </template>
                            </v-banner>
                        </v-col>
                    </v-row>
                </v-card-title> 

                <div v-if="listData.tieneCredito">
                    
                    <v-card-text >
                        <v-container >
                            <v-card color="green lighten-4" >
                            <v-list>
                                <v-list-item  >
                                    <v-list-item-title><strong> Canal Venta: </strong> {{this.listData.comer}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item  >
                                    <v-list-item-title><strong>  Producto: </strong> {{this.listData.producto}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><strong> Monto Cuota: </strong> ${{this.listData.montoCuota}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><strong> Monto Totál: </strong> ${{this.listData.montoTotal}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><strong>Saldo: </strong> ${{this.listData.saldo}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><strong> Cuotas Pagas: </strong> {{this.listData.cuotasPagas}} de {{this.listData.cuotasTotales}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title><strong> Banco Original: </strong> {{this.listData.bancoOriginal}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            </v-card>
                        </v-container>
                    </v-card-text> 

                </div>
            </v-card>  

            <v-footer fixed>
                <v-btn color="blue darken-1" text @click.stop="hideActiveTask">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <div>
                    <v-pagination 
                    v-model="legajo" 
                    :length="listData.totalLegajos" 
                    :total-visible="5"
                    @input="getData()"
                    ></v-pagination>
                    <p></p>
                </div>
            </v-footer>
    </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { format } from 'date-fns'
import {Decimal} from 'decimal.js';

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({
        infoPersona:{},
        listData: [],
        loadingData: false,
        legajo: 0
        }
    ),
    props:{
        personaId: {
            type: String,
        },
        visible: {
            type: Boolean,
            default: false
        },
    },
    async created(){
        this.fechaCuentaCorriente = this.$moment(new Date()).format('YYYY-MM-DD');
        if(this.personaId){
            this.showId = false
            this.pageCreditos = 0;
            this.items = [];
            
            await this.loadDatosPersona();
            await this.getData();
        }
    },
    computed: {
        ...mapGetters(["checkCanAccess","ParametrosGenerales"]),
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }, 
        saldoTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].saldo);                
            }
            return saldo;
        },
        importeTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].importe);
            }
            return saldo;
        },
        importeCapitalTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].capital);
            }
            return saldo;
        },
        importeInteresTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].interes);
            }
            return saldo;
        },
        importeCargosTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].cargos);
            }
            return saldo;
        },
        importePunitoriosTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].punitorios);
            }
            return saldo;
        },
        cargosAtrasoTotal: function(){
            if(!this.cuentaCorriente) return 0;

            var saldo = 0;

            for (let index = 0; index < this.cuentaCorriente.length; index++) {
                if(this.cuentaCorrienteDetallada)
                    saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].cargosAtraso);
                else
                    saldo = new Decimal(saldo).plus(this.cuentaCorriente[index].cargosAtraso + this.cuentaCorriente[index].punitorios);
            }
            return saldo;
        },
        saldoCuentaGastosTotal: function(){
            if(!this.itemsCuentaGastos) return 0;

            var saldo = 0;

            for (let index = 0; index < this.itemsCuentaGastos.length; index++) {
                if(!this.itemsCuentaGastos[index].tipo.includes('Pago'))
                    saldo = new Decimal(saldo).plus(this.itemsCuentaGastos[index].saldo);
                
            }
            return saldo;
        },
    },
    watch:{
        visible: function(){
            if(this.visible){
                this.showId = false;
                this.pageCreditos = 0;
                this.items = [];
                this.itemsCuentaGastos = [];
                this.loadDatosPersona();
            }
        },
        fechaCuentaCorriente: function(){
            if(this.creditoSeleccionado != null){
                this.verCuentaCorriente(this.creditoSeleccionado);
            }
        },
        cuentaCorrienteDetallada: function(){
            if(this.cuentaCorrienteDetallada){
                this.headersCuentaCorriente= [ // definición de columnas
                    { text: 'Fecha', value: 'fecha' , width: 100},
                    { text: 'Concepto', value: 'concepto', width: 170 },
                    { text: 'Capital', value: 'capital', width: 120},
                    { text: 'Interés', value: 'interes', width: 120},
                    { text: 'Cargos', value: 'cargos', width: 90},
                    { text: 'Punitorios', value: 'punitorios', width: 100},
                    { text: 'Cargos Atr.', value: 'cargosAtraso', width: 90},
                    { text: 'Saldo', value: 'saldo', width: 120},
                    { text: 'Situación', value: 'situacion'}];
            }
            else
            {
                this.headersCuentaCorriente= [ // definición de columnas
                    { text: 'Fecha', value: 'fecha' , width: 100},
                    { text: 'Concepto', value: 'concepto', width: 200 },
                    { text: 'Importe', value: 'importe', width: 120},
                    { text: 'Cargos x Atraso', value: 'cargosAtraso', width: 110},
                    { text: 'Saldo', value: 'saldo', width: 120},
                    { text: 'Situación', value: 'situacion'}];
            }
        },
        incluirConsultas: async function(){
            this.items = [];
            this.totalItemsCargados = 0;
            this.totalItems = 0;
            this.pageCreditos = 0;
        },
        incluirAnuladosRechazados: async function(){
            this.items = [];
            this.totalItemsCargados = 0;
            this.totalItems = 0;
            this.pageCreditos = 0;
        },
    },
    filters: {
        formatDate: function (value) {
            if (value) 
                return format(value, 'DD-MM-YYYY')        
        },
        formatMoney: function(value) {
            if(value)
            {
                if(Number.isInteger(value))
                    return '$ ' + value + '.00';
                else
                    return '$ ' + value;
            }
        }
    },
  methods:{
    ...mapMutations(["setActiveTask", "hideActiveTask","setActiveSubTask", "alertClear", "alertSuccess", "alertWarning", "alertError", "setReporteActivo"]),

    async getData(){
        this.loadingData = true;

        try {

            var result = await http.get('Personas/getresumenejecutivo?id=' + this.infoPersona.id + '&legajo=' + this.legajo);

            this.listData = result;

            this.legajo = this.listData.cuenta;

            console.log(this.listData);

        } catch (error) {
            // Error
            this.alertError(error)
        }

        this.loadingData = false;
    },  
    async loadDatosPersona(){
        // cargo los créditos de la persona
        this.loadingData = true
        try {
            var result = await http.get('personas/inforesumida?id='  +this.personaId  );

            this.infoPersona = result;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loadingData = false
    }
  }
}
</script>
